import { render } from "./feature.vue?vue&type=template&id=5dc3cd4c"
import script from "./feature.vue?vue&type=script&lang=js"
export * from "./feature.vue?vue&type=script&lang=js"

import "./feature.vue?vue&type=style&index=0&id=5dc3cd4c&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__